import React from "react";
import { apiEndpoint } from "helpers/url_helper";
import { Card, CardBody, Row, Col } from "reactstrap"
import { useEffect, useState } from 'react';
import './Miniwidget.css'
var WidgetPropsViolations = [];
const Miniwidget = props => {
  const [todaysCount, settodaysCount] = useState([]);
  const [monthCount, setmonthCount] = useState([]);
  const [todaysChange, settodaysChange] = useState([]);
  const [monthChange, setmonthChange] = useState([]);

  const [bounce, setbounce] = useState(false);


  useEffect(() => {

    var intCampusID = props.CampusID;

    const getData = async () => {
      // UserValidated
      const url = apiEndpoint + '/GetTodaysTotalViolations';
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            "intCampusID": intCampusID,
            "strToken": sessionStorage.getItem("Clear_AuthUser")
          }),

        });
        if (response.body != null) {
          const data = await response.json();
          //settodaysChange(data.percChange);
          settodaysCount(data.TotalViolationsCount);
          setbounce(true)
        }

        // UserValidated
        const urlMonth = apiEndpoint + '/GetMonthlyViolations';
        const responseMonthly = await fetch(urlMonth, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            "intCampusID": intCampusID,
            "strToken": sessionStorage.getItem("Clear_AuthUser")
          })
        });
        if (responseMonthly.body != null) {
          const dataMonthly = await responseMonthly.json();
          // setmonthChange(dataMonthly.percChange);
          setmonthCount(dataMonthly.TotalViolationsCount);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getData();
  }, [props.CampusID]);


  if (props.type == "daily") {
    WidgetPropsViolations = [
      {
        title: "Today's  Violations",
        iconClass: "cube-outline", total: todaysCount,
        average: todaysChange, badgecolor: "info", previosPeriod: "Yesterday"
      },
    ]
  }
  else if (props.type == "monthly") {
    WidgetPropsViolations = [
      {
        title: "Last Month's Violations",
        iconClass: "tag-text-outline", total: monthCount,
        average: monthChange, badgecolor: "warning", previosPeriod: "Last Month"
      }]
  }


  return (
    <React.Fragment>
      {/* <Row> */}
      {WidgetPropsViolations.map((report, key) => (
        <Col lg={3} xl={6} sm={6} key={key} >
          <div className={bounce ? 'bounce' : ''} onAnimationEnd={() => setbounce(false)} style={{ maxHeight: "120%", minHeight: "110%" }}>
            <Card className="mini-stat bg-primary  " style={{ width: '200%', display: 'inline-block', textSizeAdjust: "auto" }}
            >
              <CardBody className="card-body mini-stat-img" style={{}}>
                {/* style={{height:"23vh"}} */}


                <div className="text-white" style={{ textSizeAdjust: "auto" }}>
                  <h4 style={{ fontWeight: "bold" }} className="text-uppercase mb-3 font-size-16 text-white">{report.title}
                  </h4>
                  <div className="mini-stat-icon">
                    <i className={"float-end mdi mdi-" + report.iconClass}></i>
                  </div>
                  <h1 className="mb-4 text-white">{report.total}</h1>

                  {/* <span style={{fontSize:"normal"}} className={"badge bg-" + report.badgecolor}> {report.average}</span><span className="ms-3">% Change From {report.previosPeriod} </span>              
                  */}

                </div>

                <div style={{ fontSize: "large", display: "block", height: "2.2vh" }}></div>
              </CardBody>
            </Card>
          </div>
        </Col>
      ))}
      {/* </Row>  */}
    </React.Fragment>
  )

}

export default Miniwidget
